// extracted by mini-css-extract-plugin
export default {"СonfirmDelete":"СonfirmDelete_СonfirmDelete__tmtHD","СonfirmDeleteInner":"СonfirmDelete_СonfirmDeleteInner__q0g7l","ButtonInner":"СonfirmDelete_ButtonInner__imsEV"};